export default {
  el: {
    colorpicker: {
      confirm: 'ຢືນຢັນແນ່ນອນ',
      clear: 'ລົບຂໍ້ມູນທັງໝົດ'
    },
    datepicker: {
      now: 'ດຽວນີ້',
      today: 'ມື້​ນີ້',
      cancel: 'ຍົກເລີກ',
      clear: 'ລົບຂໍ້ມູນທັງໝົດ',
      confirm: 'ຢືນຢັນແນ່ນອນ',
      selectDate: 'ກະລຸນາເລືອກວັນທີ່',
      selectTime: 'ເລືອກເວລາ',
      startDate: 'ວັນທີ່ເລີ່ມຕົ້ນ',
      startTime: 'ເວລາເລີ່ມຕົ້ນ',
      endDate: 'ວັນທີສິ້ນສຸດ',
      endTime: 'ເວລາສິ້ນສຸດ',
      prevYear: 'ປີກາຍ',
      nextYear: 'ປີ​ຫນ້າ',
      prevMonth: 'ເດືອນແລ້ວນີ້',
      nextMonth: 'ເດືອນ​ຫນ້າ',
      year: 'ປີ',
      month1: 'ເດືອນ1',
      month2: 'ເດືອນ2',
      month3: 'ເດືອນ3',
      month4: 'ເດືອນ4',
      month5: 'ເດືອນ5',
      month6: 'ເດືອນ6',
      month7: 'ເດືອນ7',
      month8: 'ເດືອນ8',
      month9: 'ເດືອນ9',
      month10: 'ເດືອນ10',
      month11: 'ເດືອນ11',
      month12: 'ເດືອນ12',
      // week: '周次',
      weeks: {
        sun: 'ວັນອາທິດ',
        mon: 'ວັນຈັນ',
        tue: 'ວັນອັງຄານ',
        wed: 'ວັນພຸດ',
        thu: 'ວັນພະຫັດ',
        fri: 'ວັນ​ສຸກ',
        sat: 'ວັນເສົາ'
      },
      months: {
        jan: 'ມັງກອນ',
        feb: 'ກຸມພາ',
        mar: 'ມີນາ',
        apr: 'ເມສາ',
        may: 'ພຶດສະພາ',
        jun: 'ມິຖຸນາ',
        jul: 'ກໍລະກົດ',
        aug: 'ສິງຫາ',
        sep: 'ກັນຍາ',
        oct: 'ຕຸລາ',
        nov: 'ພະຈິກ',
        dec: 'ທັນວາ'
      }
    },
    select: {
      loading: 'ກຳລັງໂຫຼດ',
      noMatch: 'ບໍ່ມີຂໍ້ມູນທີ່ກົງກັນ',
      noData: 'ບໍ່​ມີ​ຂໍ້​ມູນ',
      placeholder: 'ກະລຸນາເລືອກ'
    },
    cascader: {
      noMatch: 'ບໍ່ມີຂໍ້ມູນທີ່ກົງກັນ',
      loading: 'ກຳລັງໂຫຼດ',
      placeholder: 'ກະລຸນາເລືອກ',
      noData: 'ບໍ່​ມີ​ຂໍ້​ມູນ'
    },
    pagination: {
      goto: 'ໄປ​ຫາ',
      pagesize: 'ລາຍການ / ຫນ້າ',
      total: 'ທັງໝົດ {total}ລາຍການ',
      pageClassifier: 'ຫນ້າ'
    },
    messagebox: {
      title: 'ຄໍາແນະນໍາ',
      confirm: 'ຢືນຢັນແນ່ນອນ',
      cancel: 'ຍົກເລີກ',
      error: 'ຂໍ້ມູນທີ່ຕື່ມເຂົ້າບໍ່ຖືກຕ້ອງ!'
    },
    upload: {
      deleteTip: 'ກົດປຸ່ມdeleteສາມາດລຶບໄດ້',
      delete: 'ລຶບ',
      preview: 'ກວດເບິ່ງ​ຮູບ​ພາບ​',
      continue: 'ສືບຕໍ່ການອັບໂຫຼດ'
    },
    table: {
      emptyText: 'ບໍ່​ມີ​ຂໍ້​ມູນ',
      confirmFilter: 'ຄັກເລືອກ',
      resetFilter: 'ຣີເຊັດ',
      clearFilter: 'ທັງໝົດ',
      sumText: 'ລວມ'
    },
    tree: {
      emptyText: 'ບໍ່​ມີ​ຂໍ້​ມູນ'
    },
    transfer: {
      noMatch: 'ບໍ່ມີຂໍ້ມູນທີ່ກົງກັນ',
      noData: 'ບໍ່​ມີ​ຂໍ້​ມູນ',
      titles: ['ແບບຟອມ 1', 'ແບບຟອມ 2'],
      filterPlaceholder: 'ກະລຸນາໃສ່​ເນື້ອ​ໃນທີ່ຄົ້ນ​ຫາ​',
      noCheckedFormat: 'ທັງໝົດ {total} ລາຍການ',
      hasCheckedFormat: 'ເລືອກ {checked}/{total} ລາຍການແລ້ວ'
    },
    image: {
      error: 'ໂຫຼດບໍ່ສຳເລັດ'
    },
    pageHeader: {
      title: 'ກັບຄືນ'
    },
    popconfirm: {
      confirmButtonText: 'ຢືນຢັນແນ່ນອນ',
      cancelButtonText: 'ຍົກເລີກ'
    },
    empty: {
      description: 'ບໍ່​ມີ​ຂໍ້​ມູນ'
    }
  }
};
